import { copySourceLabel } from '../utils/copy-content'
import TableMatchText from './TableMatchText'
import { Fragment } from 'react'
import TableReferenceLink from './TableReferenceLink'
import type { CellReference, CellSegment } from '../schemas'

/** Render saved reference occurrences in reading order, independent of answer wording. */
export default function CellEvidence({
  segments,
  references,
  matterId,
  tableId,
  highlightOnHover = false,
}: {
  segments: CellSegment[]
  references: CellReference[]
  matterId: string
  tableId?: string
  highlightOnHover?: boolean
}) {
  const byId = new Map(references.map((reference) => [reference.id, reference]))
  const numbers = new Map<string, number>()
  for (const segment of segments) {
    for (const id of segment.reference_ids) {
      if (!numbers.has(id)) numbers.set(id, numbers.size + 1)
    }
  }
  return (
    <span className={`whitespace-pre-wrap break-words rounded ${highlightOnHover ? '[&:hover:not(:has(a:hover))]:bg-brand-neutral-100' : ''}`}>
      {segments.map((segment, index) => (
        <Fragment key={index}>
          <TableMatchText text={segment.text} start={segments.slice(0, index).reduce((sum, part) => sum + Array.from(part.text).length, 0)} />
          {segment.reference_ids.map((id) => {
            const reference = byId.get(id)
            if (!reference) return null
            return (
              <span key={id} data-table-reference-id={id} data-table-reference-source={copySourceLabel(reference, matterId, tableId)}>
                <TableReferenceLink
                  reference={reference}
                  matterId={matterId}
                  className="mx-0.5 px-1 pt-0 pb-[1px] rounded text-xs border inline-flex items-center min-h-[18px] text-brand-neutral-800 bg-brand-neutral-200 border-brand-neutral-300 hover:bg-brand-neutral-300 transition-colors"
                >
                  {numbers.get(id)}
                </TableReferenceLink>
              </span>
            )
          })}
        </Fragment>
      ))}
    </span>
  )
}
